import 'antd/dist/antd.css';
import {Row, Col, Upload, Button, Spin} from 'antd';
import { UploadOutlined } from '@ant-design/icons';

function UploadDemo() {
    return (
        <div style={{display: 'flex',justifyContent: 'center',alignItems: 'center',height: '50vh'}}>
            <Row gutter={16}>
                <Col lg={16} sm={24} xs={24}>

                    <h1 className='mt-5'>uploadDemo</h1>

                    <Upload 
                        name='file' 
                        multiple={true} 
                        listType='picture'
                        action={'http://localhost:3000/'}
                        iconRender={ ()=> {
                            return <Spin></Spin>;
                        }}
                    >
                        <Button icon={<UploadOutlined style={{color: 'green'}}/>}>Upload Images</Button>
                    </Upload>
                </Col>
            </Row>
            
        </div>
    );
}

export default UploadDemo;